import React from 'react';

const ShowPrice = ({price, currency = "ILS", locale = 'he-IL'}) => {
    const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
    });


    return (
        <span>
            {formatter.format(price)}
        </span>
    );
};

export default ShowPrice;